import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import withTracker from './components/withTracker';
import PrivateRoutes from './components/PrivateRoutes';

import Login from './components/Users/Login';
import Logout from './components/Users/Logout';
import Registration from './components/Registration';
import QBAuthTokenDialog from "./components/Invoices/QBAuthTokenDialog";
import QBValidateEntities from "./components/Invoices/QBValidateEntities";
import RegistrationThankYou from './components/Registration/ThankYou';


import RegistrationNew from './components/RegistrationNew';

export const routes =
    <Switch>
        <Redirect exact from="/" to="/login" />
        <Route exact path='/login' component={ withTracker(Login) } />
        <Route exact path='/logout' component= { withTracker(Logout) } />
        <Route exact path='/registration/:accountId/:token' component={ withTracker(Registration) } />
        <Route exact path='/registrationThankYou' component={ withTracker(RegistrationThankYou) } />
        <Route extct path='/registrationNew/:accountId/:token' component={withTracker(RegistrationNew)} />
        <Route exact path='/QBAuthTokenDialog' component={withTracker(QBAuthTokenDialog)} />
        <Route exact path='/QBValidateEntities' component={withTracker(QBValidateEntities)} />
        <Route component={PrivateRoutes} />
    </Switch>;
